import { Dropdown, ComboBox, MultiSelect } from 'carbon-components-react'
import './index.scss'

Dropdown.ComboBox = ComboBox
Dropdown.MultiSelect = MultiSelect

export { Dropdown, ComboBox, MultiSelect, Dropdown as default }
